import { render } from "./DescripcioGeneral.vue?vue&type=template&id=e64de354"
import script from "./DescripcioGeneral.vue?vue&type=script&lang=js"
export * from "./DescripcioGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__